import React from "react";
import { useTranslation } from "react-i18next";
import { useWhitelabel } from "../../../../contexts/WhitelabelContext";
import useWindowSize from "../../../../hooks/useWindowSize";
import { Button, Form, Modal } from "react-bootstrap";
import useDeviceType from "../../../../hooks/useDeviceType";

const RegisterPaymentForm = ({
  values,
  errors,
  touched,
  setFieldValue,
  setFieldTouched,
  handleChange,
  handleBlur,
  setValues,
  setShowRegisterPaymentModal,
  initialValues,
  handleSubmit,
  invoices,
  currencyList,
}) => {
  const { t } = useTranslation();
  const { backgroundColor, fontColor } = useWhitelabel();
  const [width] = useWindowSize();
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>{t("crm.registerPayment.amount")}</Form.Label>
        <Form.Control
          type="text"
          name="amount"
          value={values.amount}
          isInvalid={Boolean(touched.amount && errors.amount)}
          onBlur={handleBlur}
          onChange={handleChange}
        />
        {!!touched.amount && (
          <Form.Control.Feedback type="invalid">
            {errors.amount}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>{t("crm.registerPayment.currency")}</Form.Label>
        <Form.Select
          name="currency"
          value={values.currency}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.currency && errors.currency}
        >
          <option value="">{t("crm.registerPayment.selectCurrency")}</option>
          {Object.keys(currencyList).map((currencyCode) => {
            const currency = currencyList[currencyCode];
            return (
              <option key={currencyCode} value={currencyCode}>
                {currencyCode} - {currency.name}
              </option>
            );
          })}
        </Form.Select>
        {!!touched.currency && (
          <Form.Control.Feedback type="invalid">
            {errors.currency}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>{t("crm.registerPayment.invoice")}</Form.Label>
        <Form.Select
          name="invoiceId"
          value={values.invoiceId}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.invoiceId && errors.invoiceId}
        >
          <option value="">{t("crm.registerPayment.selectInvoice")}</option>
          {invoices.map((invoice, index) => {
            return (
              <option key={index} value={invoice.id}>
                {invoice.id} - {invoice.amount}
              </option>
            );
          })}
        </Form.Select>
      </Form.Group>
      {isDesktop && (
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setShowRegisterPaymentModal(false)}
            className="me-2"
            style={{
              "--dynamic-bg-color": backgroundColor ?? "#0E1A2B",
              "--dynamic-font-color": fontColor ?? "#fff",
              border: "none",
            }}
          >
            {t("crm.registerPayment.cancel")}
          </Button>
          <Button
            type="submit"
            variant="primary"
            style={{
              "--dynamic-bg-color": backgroundColor,
              "--dynamic-font-color": fontColor,
              border: "none",
            }}
          >
            {t("crm.registerPayment.submit")}
          </Button>
        </Modal.Footer>
      )}
      {!isDesktop && (
        <div className="d-flex flex-column justify-content-center mt-3">
          <Button
            type="submit"
            variant="primary"
            className="mb-3"
            style={{
              "--dynamic-bg-color": backgroundColor,
              "--dynamic-font-color": fontColor,
              border: "none",
              padding: "10px",
            }}
          >
            {t("crm.registerPayment.submit")}
          </Button>
          <Button
            variant="primary"
            onClick={() => setShowRegisterPaymentModal(false)}
            style={{
              "--dynamic-bg-color": backgroundColor,
              "--dynamic-font-color": fontColor,
              border: "none",
              padding: "10px",
            }}
          >
            {t("crm.registerPayment.cancel")}
          </Button>
        </div>
      )}
    </Form>
  );
};

export default RegisterPaymentForm;
